import { apiClient } from './client';
import { API_CONFIG } from './config';

export type WhatsAppTemplateGroup = 'booking' | 'rental' | 'customer';

/** One template as the editor sees it: the live value plus what it is diffing against. */
export type WhatsAppTemplateEntity = {
  code: string;
  group: WhatsAppTemplateGroup;
  enabled: boolean;
  body: string;
  /** True when this project overrode the catalogue wording. */
  customised: boolean;
  description: string;
  variables: string[];
  defaultBody: string;
  defaultEnabled: boolean;
};

export type UpsertWhatsAppTemplateRequest = {
  body: string;
  enabled: boolean;
};

class WhatsAppApi {
  private ep = API_CONFIG.endpoints.whatsapp;

  catalogue() {
    return apiClient.get<{ data: WhatsAppTemplateEntity[] }>(this.ep.catalogue);
  }

  upsert(code: string, data: UpsertWhatsAppTemplateRequest) {
    return apiClient.put<WhatsAppTemplateEntity>(this.ep.byCode(code), data);
  }

  /** Reset to default — the override row is deleted rather than overwritten. */
  reset(code: string) {
    return apiClient.delete<WhatsAppTemplateEntity>(this.ep.byCode(code));
  }
}

export const whatsAppApi = new WhatsAppApi();
